import { z } from 'zod'
import { ServiceLogComeFrom } from '~/enums/service-log-come-from'
import { ServiceLogOperation } from '~/enums/service-log-operation'
import { serviceFileDataSchema } from './service-file-data'

/** 問題答覆記錄 - 列表資料 Schema */
export const serviceLogListDataSchema = z.object({
  /** 技術服務問題ID */
  siID: z.number(),
  /** 答覆歷程記錄ID */
  slID: z.number(),
  /** 操作人員(姓名) */
  operator: z.string().nullable(),
  /** 執行動作 */
  operation: z.nativeEnum(ServiceLogOperation),
  /** 操作時間 */
  operationDate: z.string(),
  /** 記錄內容 */
  operationContent: z.string(),
  /** 附件檔案 */
  serviceFiles: z.array(serviceFileDataSchema),
  /** 來源 */
  comefrom: z.nativeEnum(ServiceLogComeFrom)
})

/** 問題答覆記錄 - 列表資料 */
export interface ServiceLogListData
  extends z.infer<typeof serviceLogListDataSchema> {}
